<template>
  <div class="rules-upload-wrapper">
    <HeraFormInputFile
      id="rules"
      ref="rulesFile"
      output-as="binary"
      :accept="['pdf', 'PDF']"
      name="rules"
      :size-ceil="3e4"
      :label="$$t('Rules File:')"
      :preupload="true"
      :disabled="isTournamentFieldDisabled('rules_link')"
      hide-default-loader
      @filesSelected="info => onFileSelected('rules')(info)"
      @filesUploaded="info => onFileUploaded('rules')(info)"
      @uploadError="onFileError('rules')"
    />
    <div
      v-if="rulesLink || rules"
      class="d-flex align-items-center action-remove mt-3"
    >
      <a v-if="rulesLink && !rules" :href="rulesLink" target="_blank">
        {{ $$t('Rules link.pdf', 'rules-placeholder') }}
      </a>
      <div v-else-if="rules">{{ rules }}</div>
      <Icon
        v-if="rulesLink"
        class="cursor-pointer h-ml-3"
        :fill="primaryFill"
        name="delete"
        hover-icon="delete-active"
        @click="removeRulesLink"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Icon from '@/components/atoms/Icon';
import HeraFormInputFile from '@/components/form/HeraFormInputFile';
import { translate } from '@/mixins/translate';
const component = 'info';

export default {
  name: 'TournamentRulesFileSetting',
  inject: ['$validator'],
  components: {
    Icon,
    HeraFormInputFile,
  },

  mixins: [translate('_web_tournament_additional_settings')],
  data() {
    return {
      primaryFill: this.$scss.colors.primaryTextBg,
      rules: '',
    };
  },
  computed: {
    ...mapGetters([
      'currentTournament',
      'currentTournamentInfo',
      'isTournamentFieldDisabled',
    ]),
    componentData() {
      return this.currentTournamentInfo;
    },
    rulesLink: {
      get() {
        return this.$lodash.get(this.componentData, 'rules_link', '');
      },
      set(newVal) {
        this.updateCurrentTournament({
          rules_link: newVal,
          component,
        });
      },
    },
  },
  methods: {
    ...mapMutations(['updateCurrentTournament']),
    onFileSelected(property) {
      return filesInfo => {
        this[property] = filesInfo[0].name;
      };
    },
    onFileUploaded() {
      return filesInfo => {
        this.rulesLink = filesInfo[0].file_id;
        this.errors.remove('rules');
      };
    },
    onFileError(property) {
      this[property] = '';
    },
    removeRulesLink() {
      this.rulesLink = '';
      this.rules = '';
      if (this.$refs.rulesFile) {
        this.$refs.rulesFile.clearFileInput();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.rules-upload-wrapper {
  max-width: 220px;
}
</style>
